var _style, _g, _path, _path2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowhiteCspsHalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 393.2 43",
    style: {
      enableBackground: "new 0 0 393.2 43"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#247D91;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#003E4C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000002351685639177952800000010945180776708945823_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_03.Dotted-lines"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.4,
    y: 17.2,
    className: "st0",
    width: 185.9,
    height: 8.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M249.3,25.9h-14.4v-8.7h14.4V25.9z M220.6,25.9h-14.4v-8.7h14.4V25.9z M191.9,25.9h-14.4v-8.7h14.4V25.9z  M163.2,25.9h-14.4v-8.7h14.4V25.9z M134.5,25.9h-14.4v-8.7h14.4V25.9z M105.8,25.9H91.4v-8.7h14.4V25.9z M77.1,25.9H62.7v-8.7 h14.4V25.9z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M14.9,31.7V4.1H23C24.4,4,25.8,4.4,27,5c1,0.6,1.8,1.6,2.3,2.7c0.5,1.3,0.8,2.8,0.7,4.2c0.1,1.5-0.3,3-0.9,4.3 c-0.6,1.1-1.5,1.9-2.6,2.4c-1.2,0.5-2.6,0.8-3.9,0.8h-2.7v12.2h-5V31.7z M19.9,15.9h1.9c0.7,0,1.5-0.1,2.1-0.4 c0.5-0.3,0.9-0.7,1.1-1.3c0.2-0.8,0.3-1.5,0.3-2.3s-0.1-1.6-0.2-2.4c-0.1-0.6-0.5-1.1-0.9-1.4c-0.7-0.3-1.5-0.5-2.3-0.4H20v8.2H19.9 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M15,31.7V4.1h8.1c1.4-0.1,2.8,0.3,4,0.9c1,0.6,1.8,1.6,2.3,2.7c0.5,1.3,0.8,2.8,0.7,4.2c0.1,1.5-0.3,3-0.9,4.3 c-0.6,1.1-1.5,1.9-2.6,2.4c-1.2,0.5-2.6,0.8-3.9,0.8H20v12.2h-5V31.7z M20,15.9h1.9c0.7,0,1.5-0.1,2.1-0.4c0.5-0.3,0.9-0.7,1.1-1.3 c0.2-0.8,0.3-1.5,0.3-2.3s-0.1-1.6-0.2-2.4c-0.1-0.6-0.5-1.1-0.9-1.4c-0.7-0.3-1.5-0.5-2.3-0.4h-2V15.9z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39.1,38.5c-1.1,0-2.1-0.2-2.8-0.6c-0.8-0.4-1.4-1-1.8-1.8c-0.4-0.8-0.6-1.7-0.6-2.9v-5.6 c0-1.1,0.2-2.1,0.6-2.9c0.4-0.8,1-1.4,1.8-1.8s1.7-0.6,2.8-0.6s2.1,0.2,2.8,0.6c0.8,0.4,1.4,1,1.8,1.8c0.4,0.8,0.6,1.7,0.6,2.9v5.6 c0,1.1-0.2,2.1-0.6,2.9c-0.4,0.8-1,1.4-1.8,1.8C41.2,38.3,40.3,38.5,39.1,38.5z M39.2,35.7c0.3,0,0.6-0.1,0.8-0.3s0.3-0.4,0.3-0.8 s0.1-0.7,0.1-1.1v-6.1c0-0.4,0-0.8-0.1-1.2c-0.1-0.3-0.2-0.6-0.3-0.8c-0.2-0.2-0.4-0.3-0.8-0.3c-0.3,0-0.6,0.1-0.8,0.3 c-0.2,0.2-0.3,0.5-0.4,0.8c-0.1,0.3-0.1,0.7-0.1,1.2v6.1c0,0.4,0,0.8,0.1,1.1s0.2,0.6,0.4,0.8C38.6,35.6,38.8,35.7,39.2,35.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowhiteCspsHalf);
export default __webpack_public_path__ + "static/media/Powhite-CSPS-half.cdd75fbd1840012a83b091ebe6336fdd.svg";
export { ForwardRef as ReactComponent };